import { render, staticRenderFns } from "./ParagraphImage.vue?vue&type=template&id=3726fe3b&scoped=true&"
import script from "./ParagraphImage.vue?vue&type=script&lang=js&"
export * from "./ParagraphImage.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphImage.vue?vue&type=style&index=0&id=3726fe3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3726fe3b",
  null
  
)

export default component.exports